<template>
  <div class="md-layout md-alignment-center-center flex-1">
    <div
      class="md-layout-item md-size-50 md-xsmall-size-100 md-small-size-100 md-medium-size-90 md-large-size-70 md-xlarge-size-50"
    >
      <md-card>
        <md-card-header data-background-color="secondary">
          <h4 class="title">Registration Confirmation</h4>
        </md-card-header>
        <md-card-content>
          <div class="alert alert-success p-4 mb-4">
            <h3>Payment and Registration Successful!</h3>
            <p class="lead">Receipt Number: SML-0001</p>
            <p>A confirmation email has been sent to the registered email.</p>
            <div class="row g-4">
              <div
                class="col-3 col-sm-2 py-3 d-flex justify-content-center align-items-center"
              >
                <md-icon
                  :md-src="user[0].accessPassIcon"
                  class="icon-pass icon-color-white"
                />
              </div>
              <div
                class="col-9 col-sm-10 d-flex justify-content-content align-items-center"
              >
                <div>
                  <h4 class="mb-1">{{ user[0].accessPass }}</h4>
                  <h5 class="mb-1">{{ user[0].accessPassPrice }}</h5>
                  <p>Expiry Date: {{ user[0].accessPassExpiry }}</p>
                </div>
              </div>
            </div>
            <md-button class="md-white">Download Receipt</md-button>
          </div>
          <h4 class="mb-1">What to do next?</h4>
          <p>No need to print anything, just following the steps below.</p>
          <ol>
            <li>
              Visit the Market Central Office with a valid form of ID
              <strong>(Driver's License / Passport)</strong>.
            </li>
            <li>
              Smile for the camera – have your photo taken and your pass issued.
            </li>
            <li>
              Complete the
              <router-link to="induction">WHS Induction</router-link>
            </li>
            <li>
              Download the SML Trader app to receive important notifications and
              up-to-date information.
              <br />
              <a
                href="https://apps.apple.com/au/app/sml-trader/id1217341213"
                target="_blank"
              >
                <img
                  :src="require('@/assets/icons/icon_App-Store.svg')"
                  class="img-fluid m-1"
                  style="width: 150px;"
                />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.schoolenews.sydneymarkets2129&hl=en&gl=US"
                target="_blank"
              >
                <img
                  :src="require('@/assets/icons/icon_Google-Play.png')"
                  class="img-fluid m-1"
                  style="width: 150px;"
                />
              </a>
            </li>
            <li>
              Remember to ‘Like’ us on Facebook and follow
              <strong>@sydneymarkets</strong> on Instagram.
            </li>
          </ol>
          <img
            v-if="user[0].accessPassType === 'both'"
            :src="require('@/assets/img/maps/map-general_flower.jpg')"
            class="img-fluid"
          />
          <img
            v-else-if="user[0].accessPassType === 'general'"
            :src="require('@/assets/img/maps/map-general.jpg')"
            class="img-fluid"
          />
          <img
            v-else-if="user[0].accessPassType === 'flower'"
            :src="require('@/assets/img/maps/map-flower.jpg')"
            class="img-fluid"
          />
          <center>
            <md-button to="induction" class="md-primary"
              >Continue to WHS Induction</md-button
            >
            <br /><router-link to="dashboard">or go to Dashboard</router-link>
          </center>
          <br />
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { data } from "@/settings/accountDetails";

export default {
  components: {},
  data() {
    return {
      user: data
    };
  }
};
</script>
